
export default {
  slug: "guerra-de-parrillas-30e",
  basepath: "content/gallery-30enero/",
  images: [
    { width: 1197, height: 800, file: '25.jpg', name: '' },
    { width: 1197, height: 800, file: '24.jpg', name: '' },
    { width: 1199, height: 800, file: '32.jpg', name: '' },
    { width: 1199, height: 800, file: 'felipe-tobar---daniela-acevedo.jpg', name: 'Felipe Tobar y Daniela Acevedo' },
    { width: 1199, height: 800, file:  'sebastian-manubens---sabriana-weinreich---rolando-fuentes---sebastian-illanes.jpg', name: 'Sebastián Manubens, Sabriana Weinreich, Rolando Fuentes y Sebastián Illanes' },
    { width: 534, height: 800, file: '36.jpg', name: '' },
    { width: 1199, height: 800, file: 'clausia-seemann---maaria-de-los-angelees-barros.jpg', name: 'Claudia Seemann y María de los Ángeles Barros' },
    { width: 534, height: 800, file: 'jose-manuel-lara---maria-angelica-valenzuela.jpg', name: 'José Manuel Lara y María Angélica Valenzuela' },
    { width: 534, height: 800, file: 'jose-salcedo.jpg', name: 'Jorge Salcedo' },
    { width: 1199, height: 800, file: '68.jpg', name: '' },
    { width: 1199, height: 800, file: '69.jpg', name: '' },
    { width: 1199, height: 800, file: 'manuel-cardeno---enrique-gomez.jpg', name: 'Manuel Cardeno y Enrique Gómez' },
    { width: 1199, height: 800, file: '80.jpg', name: '' },
    { width: 534, height: 800, file: 'rodrigo-cosicandui.jpg', name: 'Rodrigo Cosicandui' },
    { width: 1199, height: 800, file: '42.jpg', name: '' },
    { width: 1199, height: 800, file: '56.jpg', name: '' },
    { width: 534, height: 800, file: 'eduardo-calvo.jpg', name: 'Eduardo Calvo' },
    { width: 1199, height: 800, file: 'david-berdichevsky---rodrigo-palominos.jpg', name: 'David Berdichevsky y Rodrigo Palominos' },
    { width: 1199, height: 800, file: 'elena-mendoza---hector-herrera.jpg', name: 'Elena Mendoza y Héctor Herrera' },
    { width: 534, height: 800, file: 'sabrina-weinreich.jpg', name: 'Sabrina Weinreich' },
    { width: 534, height: 800, file: '49.jpg', name: '' },
    { width: 1199, height: 800, file: 'francisca-infante---alfredo---achondo---sofia-frascapoli.jpg', name: 'Francisca Infante, Alfredo Achondo y Sofía Frascapoli' },
    { width: 1199, height: 800, file: '76.jpg', name: '' },
    { width: 1199, height: 800, file: '89.jpg', name: '' },
    { width: 1199, height: 800, file: '88.jpg', name: '' },
    { width: 1199, height: 800, file: '77.jpg', name: '' },
    { width: 1199, height: 800, file: 'fernanda-hurtado---nicolas-flanagan.jpg', name: 'Fernanda Hurtado y Nicolás Flanagan' },
    { width: 1199, height: 800, file: '11.jpg', name: '' },
    { width: 1199, height: 800, file: 'benjamin-hoyl---benjamin-alfaro.jpg', name: 'Benjamín Hoyl y Benjamín Alfaro' },
    { width: 1199, height: 800, file: 'pedrp-pablo-ortiz---pedrp-pablo-ortiz.jpg', name: 'Pedro Pablo Ortiz' },
    { width: 534, height: 800, file: '17.jpg', name: '' },
    { width: 1199, height: 800, file: '15.jpg', name: '' },
    { width: 534, height: 800, file: 'juan-carlos-payola.jpg', name: 'Juan Carlos Payola' },
  ]
}